import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes } from 'react';

type ProgressBarProps = HTMLAttributes<HTMLDivElement> & {
    readonly className?: string;
    readonly duration?: number;
};

export const ProgressBar: FunctionComponent<ProgressBarProps> = ({ className, duration = 1000, style, ...props }) => (
    <div
        className={clsx('h-[2px] w-full bg-gray-200', className)}
        style={{ animation: `progress-bar-fill ${duration}ms ease-in-out`, ...style }}
        {...props}
    />
);
